/* eslint-disable import/prefer-default-export */

/**
 * Regular expression for validating the NIT (Tax Identification Number) in Colombia.
 *
 * The NIT is used to identify taxpayers in Colombia and follows a numeric format
 * with a hyphen and a check digit at the end.
 *
 * Format:
 * - The NIT consists of 5 to 12 digits, followed by a hyphen and a single check digit.
 * - Commonly used for companies and other entities that need to report taxes in Colombia.
 *
 * @constant
 * @type {RegExp}
 * @example
 * // Valid NIT example
 * const isValidNIT = COLOMBIA_NIT_REGEX.test('123456789-0'); // true
 *
 * @example
 * // Invalid NIT example (missing check digit)
 * const isInvalidNIT = COLOMBIA_NIT_REGEX.test('123456789'); // false
 *
 * @example
 * // Invalid NIT example (incorrect format)
 * const isInvalidFormat = COLOMBIA_NIT_REGEX.test('1234-567890'); // false
 */
export const COLOMBIA_NIT_REGEX = /^\d{5,12}-\d{1}$/;
